<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                :to="`/program-p1/detail/${$route.params.id}`"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Ubah Realisasi Fisik
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-dialog v-model="dialog.form"
            @keydown.esc="dialog.form = false"
            :fullscreen="dialog.fullscreen"
            width="900"
            v-if="dialog.form"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Ubah Capaian Triwulan Bulan {{ form_capaian.month === 1 ? 'Januari' : form_capaian.month === 2 ? 'Februari' : form_capaian.month === 3 ? 'Maret' : form_capaian.month === 4 ? 'April' : form_capaian.month === 5 ? 'Mei' : form_capaian.month === 6 ? 'Juni' : form_capaian.month === 7 ? 'Juli' : form_capaian.month === 8 ? 'Agustus' : form_capaian.month === 9 ? 'September' : form_capaian.month === 10 ? 'Oktober' : form_capaian.month === 11 ? 'November' : 'Desember' }} {{ form_capaian.year }}
                </div>

                <v-spacer/>

                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.form = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text 
                class="py-0 my-4">
                <ValidationObserver 
                  ref="formTw">
                  <v-form>
                    <div>
                      <ValidationProvider
                        name="Value" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          Value
                        </div>
  
                        <v-text-field
                          v-on:keyup.enter="saveTriwulan()"
                          
                          filled
                          rounded
                          dense
  
                          onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                          type="number"
                          min="0"
  
                          @focus="$event.target.select()"
                          v-on:change="message.error = ''"
  
                          :color="set_color"
                          placeholder="Contoh. 10"
  
                          hide-details
  
                          v-model="form_capaian.value"
                          :success="form_capaian.value !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
  
                            <div v-if="form_capaian.value !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </div>

                    <v-col
                      cols="12"
                      md="3"
                      class="pb-2">
                      <div
                        class="body-2 font-weight-bold text-capitalize black--text">
                        Bukti
                      </div>
                    </v-col>

                    <v-col cols="12" md="12" class="pt-0">
                      <div class="d-flex">
                        <!-- <uploaddocument 
                          v-model="upload.document">
                          <div 
                            slot="activator">
                            <v-card
                              flat
                              class="cursor-pointer"
                              style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                              <v-card-text
                                class="py-2">
                                <div v-if="!process.document"
                                  class="d-flex align-center justify-center">
                                  <v-icon 
                                    size="28" 
                                    color="#b6b6b6">
                                    mdi-cloud-upload-outline
                                  </v-icon>

                                  <div
                                    class="black--text ml-2"
                                    style="opacity: 40%; font-weight: 500;">
                                    Upload File
                                  </div>
                                </div>

                                <div v-if="process.document"
                                  class="text-center">
                                  <v-progress-circular
                                    indeterminate
                                    size="28"
                                    color="#b6b6b6">
                                  </v-progress-circular>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </uploaddocument> -->
                        <div class="mr-3">
                          <uploadimage
                            v-model="upload.image_capaian" >
                            <div 
                              slot="activator"
                              class="cursor-pointer">
                              <v-btn
                                color="#4B4B4B"
                                elevation="0"
                                small
                                :disabled="process.image_capaian"
                                :loading="process.image_capaian"
                                min-height="30"
                                class="fs-12 white--text text-capitalize d-flex align-center"
                                style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                                
                                <span
                                  class="ml-2 ">
                                  Tambah Gambar
                                </span>
                              </v-btn>
                            </div>
                          </uploadimage>
                        </div>
                        <uploaddocument
                          v-model="upload.document_capaian" >
                          <div 
                            slot="activator"
                            class="cursor-pointer">
                            <v-btn
                              color="primary"
                              elevation="0"
                              small
                              :disabled="process.document_capaian"
                              :loading="process.document_capaian"
                              min-height="30"
                              class="fs-12 white--text text-capitalize d-flex align-center"
                              style="border-radius: 6px; font-weight: 600;">
                              <v-icon size="15">mdi-file-document</v-icon>
                              
                              <span
                                class="ml-2 ">
                                Tambah File
                              </span>
                            </v-btn>
                          </div>
                        </uploaddocument>
                      </div>

                      <div>
                        <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;" class="mt-1">
                          <tr>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                              Aksi
                            </th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                              Link
                            </th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                              Nama
                            </th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                              Keterangan
                            </th>
                          </tr>
                          <tr v-for="(item, index) in form_capaian.file_url" :key="index">
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="form_capaian.file_url.splice(index, 1)"
                                    
                                    v-bind="attrs"
                                    v-on="on"
                                    
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-trash-can-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Hapus</span>
                              </v-tooltip>
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :href="item.url"
                                    target="_blank"
                                    
                                    v-bind="attrs"
                                    v-on="on"
                                    
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                  </v-btn>
                                  <!-- <v-btn
                                    :href="'https://simpelbang.klaten.go.id/laporan/perkembangan'"
                                    target="_blank"
                                    
                                    v-bind="attrs"
                                    v-on="on"
                                    
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    :color="'#097640'"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-file-excel</v-icon>
                                  </v-btn> -->
                                </template>

                                <span>Lihat</span>
                              </v-tooltip>
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;;" class="black--text">
                              {{ item.name }}
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                              <ValidationProvider 
                                :name="`Keterangan ${item.name}`" 
                                rules="" 
                                v-slot="{ errors, valid }">
            
                                <v-text-field
                                  v-on:keydown.enter.prevent="save()"
                                  
                                  filled
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Keterangan"
            
                                  hide-details
            
                                  v-model="item.desc"
                                  :success="item.desc !== '' && valid"
                                  :error-messages="errors"
                                  required
                                  class="mb-0"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        {{ errors[0] }}
                                      </v-tooltip>
                                    </div>
            
                                    <div v-if="item.desc !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </td>
                          </tr>
                        </table>



                        <v-card-text
                          v-if="form_capaian.file_url.length === 0"
                          class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                          <div class="text-center">
                            <div class="mt-3 fs-16">
                              Belum ada data
                            </div>
                          </div>
                        </v-card-text>
                      </div>
                    </v-col>
                  </v-form>
                </ValidationObserver>

                <div v-if="message.error_capaian.length > 0"
                  class="text-center mt-6">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error_capaian }}
                    </span>
                  </div>
                </div>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions
                class="pa-4">
                <v-spacer/>

                <v-btn
                  @click="saveTriwulan()"
                  :loading="process.capaian"
                  :disabled="process.capaian"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Simpan
                </v-btn>

                <v-btn
                  @click="dialog.form = false;"
                  :disabled="process.capaian"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.bukti"
            @keydown.esc="dialog.bukti = false"
            :fullscreen="dialog.fullscreen"
            width="800"
            v-if="dialog.bukti"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Bukti Triwulan Bulan {{ form_capaian.month === 1 ? 'Januari' : form_capaian.month === 2 ? 'Februari' : form_capaian.month === 3 ? 'Maret' : form_capaian.month === 4 ? 'April' : form_capaian.month === 5 ? 'Mei' : form_capaian.month === 6 ? 'Juni' : form_capaian.month === 7 ? 'Juli' : form_capaian.month === 8 ? 'Agustus' : form_capaian.month === 9 ? 'September' : form_capaian.month === 10 ? 'Oktober' : form_capaian.month === 11 ? 'November' : 'Desember' }} {{ form_capaian.year }}
                </div>

                <v-spacer/>

                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.bukti = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text 
                class="py-0 mb-4 mt-1">

                <v-col
                  cols="12"
                  md="3"
                  class="pb-2 px-0">
                  <div
                    class="body-2 font-weight-bold text-capitalize black--text">
                    Bukti
                  </div>
                </v-col>

                <v-col cols="12" md="12" class="pt-0 px-0">
                  <div class="d-flex">
                    <!-- <uploaddocument 
                      v-model="upload.document">
                      <div 
                        slot="activator">
                        <v-card
                          flat
                          class="cursor-pointer"
                          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                          <v-card-text
                            class="py-2">
                            <div v-if="!process.document"
                              class="d-flex align-center justify-center">
                              <v-icon 
                                size="28" 
                                color="#b6b6b6">
                                mdi-cloud-upload-outline
                              </v-icon>

                              <div
                                class="black--text ml-2"
                                style="opacity: 40%; font-weight: 500;">
                                Upload File
                              </div>
                            </div>

                            <div v-if="process.document"
                              class="text-center">
                              <v-progress-circular
                                indeterminate
                                size="28"
                                color="#b6b6b6">
                              </v-progress-circular>
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>
                    </uploaddocument> -->
                  </div>

                  <div>
                    <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;" class="mt-1">
                      <tr>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                          Link
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                          Nama
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                          Keterangan
                        </th>
                      </tr>
                      <tr v-for="(item, index) in form_capaian.file_url" :key="index">
                        <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :href="item.url"
                                target="_blank"
                                
                                v-bind="attrs"
                                v-on="on"
                                
                                min-width="24" min-height="24"
                                x-small
                                rounded
                                :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                              </v-btn>
                              <!-- <v-btn
                                :href="'https://simpelbang.klaten.go.id/laporan/perkembangan'"
                                target="_blank"
                                
                                v-bind="attrs"
                                v-on="on"
                                
                                min-width="24" min-height="24"
                                x-small
                                rounded
                                :color="'#097640'"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">mdi-file-excel</v-icon>
                              </v-btn> -->
                            </template>

                            <span>Lihat</span>
                          </v-tooltip>
                        </td>
                        <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;;" class="black--text">
                          {{ item.name }}
                        </td>
                        <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                          {{ item.desc }}
                        </td>
                      </tr>
                    </table>



                    <v-card-text
                      v-if="form_capaian.file_url.length === 0"
                      class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                      <div class="text-center">
                        <div class="mt-3 fs-16">
                          Belum ada data
                        </div>
                      </div>
                    </v-card-text>
                  </div>
                </v-col>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions
                class="pa-4">
                <v-spacer/>

                <v-btn
                  @click="dialog.bukti = false;"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Tutup
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card flat v-if="process.load" >
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>

                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>
              </v-card>
              <div v-if="!process.load">
                <v-card 
                  flat
                  class="mb-5"
                  v-if="Object.keys(detail).length > 0"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <div
                      class="body-1 font-weight-bold black--text mb-4">
                      #General
                    </div>
  
                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        <div
                          class="black--text d-flex align-center mb-2">
                          {{ detail.type }}
  
                          <v-spacer />
  
                          :
                        </div>
                      </v-col>
  
                      <v-col
                        cols="9"
                        class="py-0 pl-0">
                        <div
                          class="black--text mb-2">
                          {{ detail.code }} {{ detail.code !== '' ? '-' : '' }} {{ detail.title }}
                        </div>
                      </v-col>
                    </v-row>
  
                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        <div
                          class="black--text d-flex align-center mb-2">
                          Anggaran (DPA)
  
                          <v-spacer />
  
                          :
                        </div>
                      </v-col>
  
                      <v-col
                        cols="9"
                        class="py-0 pl-0">
                        <div
                          class="black--text font-weight-bold mb-2">
                          {{ parseInt(detail.anggaran) | price }}
                        </div>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        <div
                          class="black--text d-flex align-center mb-2">
                          Anggaran P1
  
                          <v-spacer />
  
                          :
                        </div>
                      </v-col>
  
                      <v-col
                        cols="9"
                        class="py-0 pl-0">
                        <div
                          class="black--text font-weight-bold mb-2">
                          {{ parseInt(detail.anggaran_p1) | price }}
                        </div>
                      </v-col>
                    </v-row>
  
                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        <div
                          class="black--text d-flex align-center mb-2">
                          Anggaran Terakhir (PERUBAHAN)
  
                          <v-spacer />
  
                          :
                        </div>
                      </v-col>
  
                      <v-col
                        cols="9"
                        class="py-0 pl-0">
                        <div
                          class="black--text font-weight-bold mb-2">
                          {{ parseInt(detail.anggaran_perubahan) | price }}
                        </div>
                      </v-col>
                    </v-row>
  
                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        <div
                          class="black--text d-flex align-center mb-2">
                          Tahun Anggaran
  
                          <v-spacer />
  
                          :
                        </div>
                      </v-col>
  
                      <v-col
                        cols="9"
                        class="py-0 pl-0">
                        <div
                          class="black--text mb-2">
                          {{ detail.tahun_anggaran }}
                        </div>
                      </v-col>
                    </v-row>
                    
                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        <div
                          class="black--text d-flex align-center mb-2">
                          PPKOM
  
                          <v-spacer />
  
                          :
                        </div>
                      </v-col>
  
                      <v-col
                        cols="9"
                        class="py-0 pl-0">
                        <div
                          class="black--text mb-2">
                          {{ detail.ppkom_name !== '' ? detail.ppkom_name : '-' }}
                        </div>
                      </v-col>
                    </v-row>
  
                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        <div
                          class="black--text d-flex align-center">
                          PPTK
  
                          <v-spacer />
  
                          :
                        </div>
                      </v-col>
  
                      <v-col
                        cols="9"
                        class="py-0 pl-0">
                        <div
                          class="black--text">
                          {{ detail.pptk_name !== '' ? detail.pptk_name : '-' }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="3"
                        class="">
                        <div
                          class="black--text d-flex align-center">
                          Indikator
  
                          <v-spacer />
  
                          :
                        </div>
                      </v-col>
  
                      <v-col
                        cols="9"
                        class="pl-0">
                        <div
                          class="black--text">
                          {{ detail.indikator !== '' ? detail.indikator : '-' }}
                        </div>
                      </v-col>
  
                    </v-row>
  
                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        <div
                          class="black--text d-flex align-center">
                          Target Kinerja
  
                          <v-spacer />
  
                          :
                        </div>
                      </v-col>
  
                      <v-col
                        cols="9"
                        class="py-0 pl-0">
                        <div
                          class="black--text">
                          {{ detail.output !== '' ? detail.output : '-' }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card 
                  flat
                  v-if="Object.keys(detail).length > 0"
                  min-height="calc(100vh - 245px)"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text
                    class="pt-2">
                    <ValidationObserver 
                      ref="form">
                      <v-form>
  
                        <v-row v-if="form.type === 'Sub Kegiatan'">
                          <v-col
                            cols="12"
                            md="3"
                            class="mt-1 pb-2">
                            <div
                              class="body-2 font-weight-bold text-capitalize black--text">
                              #Realisasi Fisik Bulanan
                            </div>
                          </v-col>
                        </v-row>
  
                        <v-row v-if="form.type === 'Sub Kegiatan'">
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Januari" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Januari
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
                                
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_1"
                                :success="form.realisasi_fisik_1 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_1 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <!-- $route.query.year < new Date().getFullYear() || user.role === 'admin' ? false : new Date() < new Date(dpa.perubahan_date) ? user.role === 'admin' ? false : input_disable[1] === '1' ? false : true : true" -->
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Februari" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Februari
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
                                
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_2"
                                :success="form.realisasi_fisik_2 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_2 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Maret" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Maret
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
                                
                               :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_3"
                                :success="form.realisasi_fisik_3 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_3 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="April" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                April
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_4"
                                :success="form.realisasi_fisik_4 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_4 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Mei" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Mei
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_5"
                                :success="form.realisasi_fisik_5 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_5 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Juni" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Juni
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_6"
                                :success="form.realisasi_fisik_6 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_6 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Juli" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Juli
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_7"
                                :success="form.realisasi_fisik_7 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_7 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Agustus" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Agustus
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_8"
                                :success="form.realisasi_fisik_8 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_8 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="September" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                September
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_9"
                                :success="form.realisasi_fisik_9 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_9 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Oktober" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Oktober
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_10"
                                :success="form.realisasi_fisik_10 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_10 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="November" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                November
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_11"
                                :success="form.realisasi_fisik_11 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_11 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Desember" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Desember
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
  
                                @focus="$event.target.select()"
                                v-on:change="message.error = ''"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.realisasi_fisik_12"
                                :success="form.realisasi_fisik_12 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_fisik_12 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
  
                        <v-row v-if="form.type === 'Sub Kegiatan'">
                          <v-col
                            cols="12"
                            md="3"
                            class="pb-2">
                            <div
                              class="body-2 font-weight-bold text-capitalize black--text">
                              #Realisasi Keuangan Bulanan
                            </div>
                          </v-col>
                        </v-row>
  
                        <v-row v-if="form.type === 'Sub Kegiatan'">
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Januari" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Januari
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="$route.query.year < new Date().getFullYear() || user.role === 'admin' ? false : new Date() < new Date(dpa.perubahan_date) ? user.role === 'admin' ? false : input_disable[0] === '1' ? false : true : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_1"
                                :success="form.realisasi_keu_1 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_1 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Februari" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Februari
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_2"
                                :success="form.realisasi_keu_2 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_2 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Maret" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Maret
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_3"
                                :success="form.realisasi_keu_3 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_3 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="April" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                April
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_4"
                                :success="form.realisasi_keu_4 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_4 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Mei" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Mei
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_5"
                                :success="form.realisasi_keu_5 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_5 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Juni" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Juni
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_6"
                                :success="form.realisasi_keu_6 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_6 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Juli" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Juli
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_7"
                                :success="form.realisasi_keu_7 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_7 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Agustus" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Agustus
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_8"
                                :success="form.realisasi_keu_8 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_8 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="September" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                September
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_9"
                                :success="form.realisasi_keu_9 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_9 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Oktober" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Oktober
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_10"
                                :success="form.realisasi_keu_10 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_10 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="November" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                November
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_11"
                                :success="form.realisasi_keu_11 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_11 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Desember" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Desember
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                :disabled="user.role === 'admin' ? false : true"
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
  
                                v-model="form.realisasi_keu_12"
                                :success="form.realisasi_keu_12 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.realisasi_keu_12 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
  
                        <v-row class="my-3" v-if="$route.query.year >= new Date().getFullYear()">
                          <v-col cols="12" md="3" class="pb-2">
                            <div class="body-2 font-weight-bold text-capitalize black--text mb-2 d-flex align-center">
                              <div>
                                Capaian Triwulan 1
                              </div>
                            </div>
                            <div>
                              <table style="width: auto; border-collapse: collapse;">
                                <tr>
                                  <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_1, capaian.file_url_1, 1)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_1, capaian.file_url_1, 1)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="width: 1px; white-space: nowrap;" class="black--text py-2 pl-1">
                                    Januari
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_1 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="width: 40px; min-width: 40px; max-width: 40px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_2, capaian.file_url_2, 2)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_2, capaian.file_url_2, 2)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    Februari
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_2 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="width: 40px; min-width: 40px; max-width: 40px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_3, capaian.file_url_3, 3)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_3, capaian.file_url_3, 3)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    Maret
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_3 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                              </table>
                              <v-divider class="mt-2"></v-divider>
                              <table style="width: auto; border-collapse: collapse;">
                                <tr>
                                  <td style=" width: 1px; white-space: nowrap;" class="fs-12 black--text font-weight-bold py-2 pl-1 ">
                                    Total
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text font-weight-bold text-right py-2 pr-2 fs-12">
                                    {{ (capaian.value_1*1)+(capaian.value_2*1)+(capaian.value_3*1) }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </v-col>
  
                          <v-col cols="12" md="3" class="pb-2">
                            <div class="body-2 font-weight-bold text-capitalize black--text mb-2 d-flex align-center">
                              <div>
                                Capaian Triwulan 2
                              </div>
                            </div>
                            <div>
                              <table style="width: auto; border-collapse: collapse;">
                                <tr>
                                   <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_4, capaian.file_url_4, 4)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_4, capaian.file_url_4, 4)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    April
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_4 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                                <tr>
                                   <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_5, capaian.file_url_5, 5)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_5, capaian.file_url_5, 5)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    Mei
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_5 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_6, capaian.file_url_6, 6)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_6, capaian.file_url_6, 6)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    Juni
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_6 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                              </table>
                              <v-divider class="mt-2"></v-divider>
                              <table style="width: auto; border-collapse: collapse;">
                                <tr>
                                  <td style=" width: 1px; white-space: nowrap;" class="fs-12 black--text font-weight-bold py-2 pl-1">
                                    Total
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text font-weight-bold text-right py-2 pr-2 fs-12">
                                    {{ (capaian.value_4*1)+(capaian.value_5*1)+(capaian.value_6*1) }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </v-col>
  
                          <v-col cols="12" md="3" class="pb-2">
                            <div class="body-2 font-weight-bold text-capitalize black--text mb-2 d-flex align-center">
                              <div>
                                Capaian Triwulan 3
                              </div>
                            </div>
                            <div>
                              <table style="width: auto; border-collapse: collapse;">
                                <tr>
                                  <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_7, capaian.file_url_7, 7)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_7, capaian.file_url_7, 7)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    Juli
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_7 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_8, capaian.file_url_8, 8)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_8, capaian.file_url_8, 8)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    Agustus
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_8 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_9, capaian.file_url_9, 9)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_9, capaian.file_url_9, 9)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    September
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_9 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                              </table>
                              <v-divider class="mt-2"></v-divider>
                              <table style="width: auto; border-collapse: collapse;">
                                <tr>
                                  <td style=" width: 1px; white-space: nowrap;" class="fs-12 black--text font-weight-bold py-2 pl-1">
                                    Total
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text font-weight-bold text-right py-2 pr-2 fs-12">
                                    {{ (capaian.value_7*1)+(capaian.value_8*1)+(capaian.value_9*1) }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </v-col>
  
                          <v-col cols="12" md="3" class="pb-2">
                            <div class="body-2 font-weight-bold text-capitalize black--text mb-2 d-flex align-center">
                              <div>
                                Capaian Triwulan 4
                              </div>
                            </div>
                            <div>
                              <table style="width: auto; border-collapse: collapse;">
                                <tr>
                                  <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_10, capaian.file_url_10, 10)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_10, capaian.file_url_10, 10)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    Oktober
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_10 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_11, capaian.file_url_11, 11)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_11, capaian.file_url_11, 11)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    November
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_11 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="width: 70px; min-width: 70px; max-width: 70px;" class="black--text py-2 pl-1">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.form = true; reset(capaian.id, capaian.value_12, capaian.file_url_12, 12)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="primary"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-square-edit-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Ubah</span>
                                    </v-tooltip>
  
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="dialog.bukti = true; reset(capaian.id, capaian.value_12, capaian.file_url_12, 12)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="22" min-height="22"
                                          x-small
                                          rounded
                                          color="green"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 4px;">
                                          <v-icon size="13">mdi-file-document</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Bukti</span>
                                    </v-tooltip>
                                  </td>
                                  <td style=" width: 1px; white-space: nowrap;" class="black--text py-2 pl-1 fs-12">
                                    Desember
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    :
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text text-right py-2 pr-2 fs-12">
                                    {{ capaian.value_12 }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                              </table>
                              <v-divider class="mt-2"></v-divider>
                              <table style="width: auto; border-collapse: collapse;">
                                <tr>
                                  <td style=" width: 1px; white-space: nowrap;" class="fs-12 black--text font-weight-bold py-2 pl-1">
                                    Total
                                  </td>
                                  <td style="min-width: 30px; max-width: 30px; width: 30px;" class="text-center black--text py-2">
                                    
                                  </td>
                                  <td style="width: 100%" class="px-0 py-1 black--text font-weight-bold text-right py-2 pr-2 fs-12">
                                    {{ (capaian.value_10*1)+(capaian.value_11*1)+(capaian.value_12*1) }} {{ detail.output.split(' ')[1] }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </v-col>
                        </v-row>
  
  
                        <v-row v-if="form.type === 'Sub Kegiatan' && (((form.realisasi_fisik_12*1) === 100) || ((form.realisasi_fisik_11*1) === 100) || ((form.realisasi_fisik_10*1) === 100) || ((form.realisasi_fisik_9*1) === 100) || ((form.realisasi_fisik_8*1) === 100) || ((form.realisasi_fisik_7*1) === 100) || ((form.realisasi_fisik_6*1) === 100) || ((form.realisasi_fisik_5*1) === 100) || ((form.realisasi_fisik_4*1) === 100) || ((form.realisasi_fisik_3*1) === 100) || ((form.realisasi_fisik_2*1) === 100) || ((form.realisasi_fisik_1*1) === 100))">
                          <v-col
                            cols="12"
                            md="3"
                            class="pb-2">
                            <div
                              class="body-2 font-weight-bold text-capitalize black--text">
                              Bukti
                            </div>
                          </v-col>
  
                          <v-col cols="12" md="12" class="pt-0">
                            <div class="d-flex">
                              <!-- <uploaddocument 
                                v-model="upload.document">
                                <div 
                                  slot="activator">
                                  <v-card
                                    flat
                                    class="cursor-pointer"
                                    style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                                    <v-card-text
                                      class="py-2">
                                      <div v-if="!process.document"
                                        class="d-flex align-center justify-center">
                                        <v-icon 
                                          size="28" 
                                          color="#b6b6b6">
                                          mdi-cloud-upload-outline
                                        </v-icon>
  
                                        <div
                                          class="black--text ml-2"
                                          style="opacity: 40%; font-weight: 500;">
                                          Upload File
                                        </div>
                                      </div>
  
                                      <div v-if="process.document"
                                        class="text-center">
                                        <v-progress-circular
                                          indeterminate
                                          size="28"
                                          color="#b6b6b6">
                                        </v-progress-circular>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </div>
                              </uploaddocument> -->
                              <div class="mr-3">
                                <uploadimage
                                  v-model="upload.image" >
                                  <div 
                                    slot="activator"
                                    class="cursor-pointer">
                                    <v-btn
                                      color="#4B4B4B"
                                      elevation="0"
                                      small
                                      :disabled="process.image"
                                      :loading="process.image"
                                      min-height="30"
                                      class="fs-12 white--text text-capitalize d-flex align-center"
                                      style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                      <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                                      
                                      <span
                                        class="ml-2 ">
                                        Tambah Gambar
                                      </span>
                                    </v-btn>
                                  </div>
                                </uploadimage>
                              </div>
                              <uploaddocument
                                v-model="upload.document" >
                                <div 
                                  slot="activator"
                                  class="cursor-pointer">
                                  <v-btn
                                    color="primary"
                                    elevation="0"
                                    small
                                    :disabled="process.document"
                                    :loading="process.document"
                                    min-height="30"
                                    class="fs-12 white--text text-capitalize d-flex align-center"
                                    style="border-radius: 6px; font-weight: 600;">
                                    <v-icon size="15">mdi-file-document</v-icon>
                                    
                                    <span
                                      class="ml-2 ">
                                      Tambah File
                                    </span>
                                  </v-btn>
                                </div>
                              </uploaddocument>
                            </div>
  
                            <div>
                              <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;" class="mt-1">
                                <tr>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    Aksi
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    Link
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                    Nama
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    Keterangan
                                  </th>
                                </tr>
                                <tr v-for="(item, index) in file" :key="index">
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="file.splice(index, 1)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="24" min-height="24"
                                          x-small
                                          rounded
                                          color="red"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon size="15">mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Hapus</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          :href="item.url"
                                          target="_blank"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="24" min-height="24"
                                          x-small
                                          rounded
                                          :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                        </v-btn>
                                        <!-- <v-btn
                                          :href="'https://simpelbang.klaten.go.id/laporan/perkembangan'"
                                          target="_blank"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="24" min-height="24"
                                          x-small
                                          rounded
                                          :color="'#097640'"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon size="15">mdi-file-excel</v-icon>
                                        </v-btn> -->
                                      </template>
  
                                      <span>Lihat</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;;" class="black--text">
                                    {{ item.name }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    <ValidationProvider 
                                      :name="`Keterangan ${item.name}`" 
                                      rules="" 
                                      v-slot="{ errors, valid }">
                  
                                      <v-text-field
                                        v-on:keydown.enter.prevent="save()"
                                        
                                        filled
                                        rounded
                                        dense
                  
                                        :color="set_color"
                                        placeholder="Keterangan"
                  
                                        hide-details
                  
                                        v-model="item.desc"
                                        :success="item.desc !== '' && valid"
                                        :error-messages="errors"
                                        required
                                        class="mb-0"
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                  
                                          <div v-if="item.desc !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div>
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </td>
                                </tr>
                              </table>
  
  
  
                              <v-card-text
                                v-if="file.length === 0"
                                class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                                <div class="text-center">
                                  <div class="mt-3 fs-16">
                                    Belum ada data
                                  </div>
                                </div>
                              </v-card-text>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </ValidationObserver>
  
                    <div v-if="message.error.length > 0"
                      class="text-center my-4 d-flex align-center">
                      <div
                        class="error--text">
                        <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            v-if="!process.load"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form || user.role === 'admin' ? false : true"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                :to="`/program-p1/detail/${$route.params.id}`"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import moment, { unix } from "moment"
  import "moment/locale/id"
import { ValidationProvider } from "vee-validate";
  export default {
    data () {
      return {
        detail: {},
        file: [],
        dialog: {
          form: false,
          fullscreen: false,
          bukti: false
        },
        upload: {
          document: null,
          image: null,
          image_capaian: null,
          document_capaian: null
        },
        form: {
          id: '',

          // Field Bantu
          program_id: '',
          kegiatan_id: '',

          par_id: 0,
          par_name: '',
          code: '',
          title: '',
          type: 'Program',
          type_index: 0,

          anggaran_before: 0,
          anggaran: 0,
          anggaran_p1: 0,
          anggaran_perubahan: 0,
          
          tahun_anggaran: Number(moment().format('YYYY')),
          tahun_anggaran_text: '',

          unit_id: '',
          unit_name: '',

          target_keu_1: 0,
          target_keu_2: 0,
          target_keu_3: 0,
          target_keu_4: 0,
          target_keu_5: 0,
          target_keu_6: 0,
          target_keu_7: 0,
          target_keu_8: 0,
          target_keu_9: 0,
          target_keu_10: 0,
          target_keu_11: 0,
          target_keu_12: 0,

          target_fisik_1: 0,
          target_fisik_2: 0,
          target_fisik_3: 0,
          target_fisik_4: 0,
          target_fisik_5: 0,
          target_fisik_6: 0,
          target_fisik_7: 0,
          target_fisik_8: 0,
          target_fisik_9: 0,
          target_fisik_10: 0,
          target_fisik_11: 0,
          target_fisik_12: 0,

          realisasi_keu_1: 0,
          realisasi_keu_2: 0,
          realisasi_keu_3: 0,
          realisasi_keu_4: 0,
          realisasi_keu_5: 0,
          realisasi_keu_6: 0,
          realisasi_keu_7: 0,
          realisasi_keu_8: 0,
          realisasi_keu_9: 0,
          realisasi_keu_10: 0,
          realisasi_keu_11: 0,
          realisasi_keu_12: 0,

          realisasi_fisik_1: 0,
          realisasi_fisik_2: 0,
          realisasi_fisik_3: 0,
          realisasi_fisik_4: 0,
          realisasi_fisik_5: 0,
          realisasi_fisik_6: 0,
          realisasi_fisik_7: 0,
          realisasi_fisik_8: 0,
          realisasi_fisik_9: 0,
          realisasi_fisik_10: 0,
          realisasi_fisik_11: 0,
          realisasi_fisik_12: 0,

          ppkom_name: '',
          pptk_name: '',

          is_excluded: 'tidak'
        },
        capaian: {
          file_url_1: "",
          file_url_2: "",
          file_url_3: "",
          file_url_4: "",
          file_url_5: "",
          file_url_6: "",
          file_url_7: "",
          file_url_8: "",
          file_url_9: "",
          file_url_10: "",
          file_url_11: "",
          file_url_12: "",
          id: "",
          task_id: "",
          unit_id: "",
          value_1: "0",
          value_2: "0",
          value_3: "0",
          value_4: "0",
          value_5: "0",
          value_6: "0",
          value_7: "0",
          value_8: "0",
          value_9: "0",
          value_10: "0",
          value_11: "0",
          value_12: "0",
          year: ""
        },
        triwulan: 0,
        form_capaian: {
          id: "",
          year: "",
          month: "",
          value: "",
          file_url: ""
        },
        input_disable: [],

        process: {
          form: false,
          document: false,
          image: false,
          capaian: false,
          load: true
        },
        
        message: {
          success: '',
          error: '',
          error_capaian: ''
        }
      }
    },
    components: {
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/document_kendala_name.vue'),
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder_name.vue')
    },
    watch: {
      'upload.document': {
        handler: function () {
          if (this.upload.document) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.document = this.upload.document.process
            
            if (!this.process.document) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              var extension = this.upload.document.data.file_url.match(regexp);
              this.file.push({
                url: this.upload.document.data.file_url,
                name: this.upload.document.data.file_name,
                decs: this.form.decs,
                type: extension[1]
              })

              this.upload.document = null

              // this.form.request_file_object.url = this.upload.doc.data.file_url
            }
          }
        },
        deep: true
      },
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.image = this.upload.image.process
            
            if (!this.process.image) {
              // var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              // var extension = this.upload.image.data.file_url.match(regexp);
              this.file.push({
                url: this.upload.image.fileuri,
                name: this.upload.image.filename,
                decs: this.form.decs,
                type: 'image'
              })

              this.upload.image = null

              // this.form.request_file_object.url = this.upload.doc.data.file_url
            }
          }
        },
        deep: true
      },


      'upload.document_capaian': {
        handler: function () {
          if (this.upload.document_capaian) {
            // this.form.request_file_object.type = 'file'
            this.message.error_capaian = ''
            this.process.document_capaian = this.upload.document_capaian.process
            
            if (!this.process.document_capaian) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              var extension = this.upload.document_capaian.data.file_url.match(regexp);
              this.form_capaian.file_url.push({
                url: this.upload.document_capaian.data.file_url,
                name: this.upload.document_capaian.data.file_name,
                decs: this.form.decs,
                type: extension[1]
              })

              this.upload.document_capaian = null

              // this.form.request_file_object.url = this.upload.doc.data.file_url
            }
          }
        },
        deep: true
      },
      'upload.image_capaian': {
        handler: function () {
          if (this.upload.image_capaian) {
            // this.form.request_file_object.type = 'file'
            this.message.error_capaian = ''
            this.process.image_capaian = this.upload.image_capaian.process
            
            if (!this.process.image_capaian) {
              // var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              // var extension = this.upload.image_capaian.data.file_url.match(regexp);
              this.form_capaian.file_url.push({
                url: this.upload.image_capaian.fileuri,
                name: this.upload.image_capaian.filename,
                decs: this.form.decs,
                type: 'image'
              })

              this.upload.image_capaian = null

              // this.form.request_file_object.url = this.upload.doc.data.file_url
            }
          }
        },
        deep: true
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      dpa () {
        return this.$store.state.dpa
      },
      mount () {
        return new Date(this.$store.state.dpa.perubahan_date).getMonth() + 1
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      // this.fetchDetail()
      this.fetchUnit()
    },
    methods: {
      async fetchUnit () {
        let params = {
          id: this.$route.query.unit_id,
          year: new Date().getFullYear()
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data = res.results.data[0]
            this.input_disable = data.unit_edit
            this.fetchCapaian()
          }
        })
      },
      async fetchCapaian () {
        let params = {
          unit_id: this.$route.query.unit_id,
          task_id: this.$route.params.id,
          year: this.$route.query.year,
          dpa_status: 'p1'
        }

        await get('admin/capaian/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.fetchDetail()
            this.capaian = res.results.data.length > 0 ? res.results.data[0] : this.capaian

            if (res.results.data.length > 0) {
              this.capaian.file_url_1 = res.results.data[0].file_url_1 !== '' ? JSON.parse(res.results.data[0].file_url_1) : []
              this.capaian.file_url_2 = res.results.data[0].file_url_2 !== '' ? JSON.parse(res.results.data[0].file_url_2) : []
              this.capaian.file_url_3 = res.results.data[0].file_url_3 !== '' ? JSON.parse(res.results.data[0].file_url_3) : []
              this.capaian.file_url_4 = res.results.data[0].file_url_4 !== '' ? JSON.parse(res.results.data[0].file_url_4) : []
              this.capaian.file_url_5 = res.results.data[0].file_url_5 !== '' ? JSON.parse(res.results.data[0].file_url_5) : []
              this.capaian.file_url_6 = res.results.data[0].file_url_6 !== '' ? JSON.parse(res.results.data[0].file_url_6) : []
              this.capaian.file_url_7 = res.results.data[0].file_url_7 !== '' ? JSON.parse(res.results.data[0].file_url_7) : []
              this.capaian.file_url_8 = res.results.data[0].file_url_8 !== '' ? JSON.parse(res.results.data[0].file_url_8) : []
              this.capaian.file_url_9 = res.results.data[0].file_url_9 !== '' ? JSON.parse(res.results.data[0].file_url_9) : []
              this.capaian.file_url_10 = res.results.data[0].file_url_10 !== '' ? JSON.parse(res.results.data[0].file_url_10) : []
              this.capaian.file_url_11 = res.results.data[0].file_url_11 !== '' ? JSON.parse(res.results.data[0].file_url_11) : []
              this.capaian.file_url_12 = res.results.data[0].file_url_12 !== '' ? JSON.parse(res.results.data[0].file_url_12) : []
            }
          }
        })
      },
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/task/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data = res.results.data
            this.detail = data

            this.form = {
              id: data.id,


              par_id: data.par_id,
              code: data.code,
              title: data.title,
              type: data.type,

              anggaran: data.anggaran,
              anggaran_p1: data.anggaran_p1,
              anggaran_perubahan: data.anggaran_perubahan,
          
              tahun_anggaran: Number(data.tahun_anggaran),
              tahun_anggaran_text: data.tahun_anggaran_text,

              unit_id: data.unit_id,
              unit_name: data.unit_name,

              target_keu_1: Number(data.target_keu_1),
              target_keu_2: Number(data.target_keu_2),
              target_keu_3: Number(data.target_keu_3),
              target_keu_4: Number(data.target_keu_4),
              target_keu_5: Number(data.target_keu_5),
              target_keu_6: Number(data.target_keu_6),
              target_keu_7: Number(data.target_keu_7),
              target_keu_8: Number(data.target_keu_8),
              target_keu_9: Number(data.target_keu_9),
              target_keu_10: Number(data.target_keu_10),
              target_keu_11: Number(data.target_keu_11),
              target_keu_12: Number(data.target_keu_12),

              target_fisik_1: Number(data.target_fisik_1),
              target_fisik_2: Number(data.target_fisik_2),
              target_fisik_3: Number(data.target_fisik_3),
              target_fisik_4: Number(data.target_fisik_4),
              target_fisik_5: Number(data.target_fisik_5),
              target_fisik_6: Number(data.target_fisik_6),
              target_fisik_7: Number(data.target_fisik_7),
              target_fisik_8: Number(data.target_fisik_8),
              target_fisik_9: Number(data.target_fisik_9),
              target_fisik_10: Number(data.target_fisik_10),
              target_fisik_11: Number(data.target_fisik_11),
              target_fisik_12: Number(data.target_fisik_12),

              realisasi_keu_1: Number(data.realisasi_keu_1),
              realisasi_keu_2: Number(data.realisasi_keu_2),
              realisasi_keu_3: Number(data.realisasi_keu_3),
              realisasi_keu_4: Number(data.realisasi_keu_4),
              realisasi_keu_5: Number(data.realisasi_keu_5),
              realisasi_keu_6: Number(data.realisasi_keu_6),
              realisasi_keu_7: Number(data.realisasi_keu_7),
              realisasi_keu_8: Number(data.realisasi_keu_8),
              realisasi_keu_9: Number(data.realisasi_keu_9),
              realisasi_keu_10: Number(data.realisasi_keu_10),
              realisasi_keu_11: Number(data.realisasi_keu_11),
              realisasi_keu_12: Number(data.realisasi_keu_12),

              realisasi_fisik_1: Number(data.realisasi_fisik_1),
              realisasi_fisik_2: Number(data.realisasi_fisik_2),
              realisasi_fisik_3: Number(data.realisasi_fisik_3),
              realisasi_fisik_4: Number(data.realisasi_fisik_4),
              realisasi_fisik_5: Number(data.realisasi_fisik_5),
              realisasi_fisik_6: Number(data.realisasi_fisik_6),
              realisasi_fisik_7: Number(data.realisasi_fisik_7),
              realisasi_fisik_8: Number(data.realisasi_fisik_8),
              realisasi_fisik_9: Number(data.realisasi_fisik_9),
              realisasi_fisik_10: Number(data.realisasi_fisik_10),
              realisasi_fisik_11: Number(data.realisasi_fisik_11),
              realisasi_fisik_12: Number(data.realisasi_fisik_12),

              ppkom_name: data.ppkom_name,
              pptk_name: data.pptk_name,

              is_excluded: data.is_excluded
            }

            this.fetchDpa()
          }
        })
      },
      async fetchDpa () {
        let params = {
          tahun:  this.form.tahun_anggaran
        }
        await get('admin/dpa/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {

            TokenService.saveDpa(JSON.stringify(res.results.data[0]))

            this.$store.commit("setDpa", res.results.data[0])
            this.process.load = false
          }
        })
      },

      reset (id, item, file, tw) {
        this.message.error = ''
        this.process.form = false
        this.form_capaian = {
          id: id,
          year: this.$route.query.year,
          month: tw,
          value: item,
          file_url: file
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate(),
              isDocument = this.form.realisasi_fisik_1*1 === 100 || this.form.realisasi_fisik_2*1 === 100 || this.form.realisasi_fisik_3*1 === 100 || this.form.realisasi_fisik_4*1 === 100 || this.form.realisasi_fisik_5*1 === 100 || this.form.realisasi_fisik_6*1 === 100 || this.form.realisasi_fisik_7*1 === 100 || this.form.realisasi_fisik_8*1 === 100 || this.form.realisasi_fisik_9*1 === 100 || this.form.realisasi_fisik_10*1 === 100 || this.form.realisasi_fisik_11*1 === 100 || this.form.realisasi_fisik_12*1 === 100 ? this.file.length > 0 ? true : false : true

        this.message.error = isDocument ? '' : 'File belum diunggah'
        if (isValid && isDocument) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/task/update`, {
            data: {
              ...this.form,
              realisasi_fisik_url_1: (this.form.realisasi_fisik_1*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_2: (this.form.realisasi_fisik_2*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_3: (this.form.realisasi_fisik_3*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_4: (this.form.realisasi_fisik_4*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_5: (this.form.realisasi_fisik_5*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_6: (this.form.realisasi_fisik_6*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_7: (this.form.realisasi_fisik_7*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_8: (this.form.realisasi_fisik_8*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_9: (this.form.realisasi_fisik_9*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_10: (this.form.realisasi_fisik_10*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_11: (this.form.realisasi_fisik_11*1) === 100 ? JSON.stringify(this.file) : 'kosong',
              realisasi_fisik_url_12: (this.form.realisasi_fisik_12*1) === 100 ? JSON.stringify(this.file) : 'kosong'
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              let url_back = this.$route.query.from === 'table' ? '/program-p1' : `/program-p1/detail/${this.$route.params.id}?unit_id=${this.$route.query.unit_id}&year=${this.$route.query.year}`

              this.$router.push({ path: url_back })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async saveTriwulan () {
        this.message.error_capaian = ''
        this.message.error = ''

        const isValid = await this.$refs.formTw.validate(),
              isDocument = this.form_capaian.value*1 === 0 ? true : this.form_capaian.file_url.length < 1 ? false : true

        this.message.error_capaian = isDocument ? '' : 'File belum diunggah'
        if (isValid && isDocument) {
          this.process.capaian = true

          // SAVE TO REST API
          await post(`admin/capaian/update`, {
            data: {
              ...this.form_capaian,
              file_url: this.form_capaian.file_url.length > 0 ? JSON.stringify(this.form_capaian.file_url) : ''
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              if (this.form_capaian.file_url.length > 0) {
                this.process.capaian = false
                this.dialog.form = false
                this.fetchCapaian()
              } else {
                this.deleteFileTriwulan()
              }


            } else {
              this.message.error_capaian = res.message
              this.dialog.form = false
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async deleteFileTriwulan () {
        this.message.error_capaian = ''
        this.message.error = ''
          this.process.capaian = true

          // SAVE TO REST API
        await post(`admin/capaian/hapus_file`, {
          data: {
            id: this.form_capaian.id,
            year: this.form_capaian.year,
            month: this.form_capaian.month
          }
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.process.capaian = false
            this.dialog.form = false
            this.fetchCapaian()

          } else {
            this.message.error_capaian = res.message
          }
        })
      }

    }
  }
</script>